export default __webpack_public_path__ + "static/media/kadra_sylwia_s.8ff78bc9.jpeg";